module.exports = __webpack_public_path__ + "static/media/63.a9af796b.webp";